import type { SVGProps } from 'react'
const SvgSyDocument = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M8.496 15.473a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h7.22a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75zm0-4.186a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h7.22a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75zm0-4.177a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h2.756a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="m15.908 2-3.84.002-3.85.002h-.003c-1.544.01-2.88.538-3.805 1.498C3.486 4.462 3 5.818 3 7.357v9.196c0 1.546.488 2.907 1.42 3.869S6.7 21.91 8.256 21.91l3.84-.002 3.85-.002h.003c1.544-.01 2.883-.538 3.807-1.498s1.41-2.316 1.41-3.855V7.357c0-1.546-.49-2.907-1.422-3.869C18.812 2.527 17.464 2 15.908 2m0 1.5c1.228 0 2.134.385 2.76 1.031s.998 1.59.998 2.826v9.196c0 1.23-.37 2.17-.99 2.814-.621.645-1.518 1.032-2.735 1.04l-3.845.001-3.84.002c-1.228 0-2.132-.385-2.758-1.031S4.5 17.79 4.5 16.553V7.357c0-1.23.37-2.17.99-2.814s1.516-1.03 2.729-1.04l3.85-.001z"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyDocument
